export default __webpack_public_path__ + "static/media/tarra-h2h-picturemark-l.11f410ac.svg";